import {useState} from 'react';
import List from '@mui/material/List';
import { Typography, Box, Paper, Divider } from '@mui/material';
import LowStockExpiringInventoryListItems from './LowStockExpiringInventoryListItems';

export default function LowStockExpiringInventoryItemsList({ pet = null, mode = 'pet'}) {

  const [listEmpty, setListEmpty] = useState(true);

  return(
      <Paper 
        elevation={3} 
        sx={{ 
          p: 2, 
          borderRadius: 2, 
        }}
      >
      <Typography variant="h6">Low Stock and Expiring Items</Typography>
      <br />
      {listEmpty ? 
        <Divider variant="fullWidth" component="li">
          <Typography variant="caption" color="text.secondary">
            no low stock or expiring items
          </Typography>
        </Divider>
      : null}
      <Box sx={{
        maxHeight: 300,
        overflow: "auto"
      }}>
        <List >
          <LowStockExpiringInventoryListItems
            setListEmpty={setListEmpty}
          />
        </List>
      </Box>
      </Paper>
  );
}